import DEFAULT_MOBILE_STEPPER_CLASS_NAME from '../../constants/mobile-stepper';

const defaultMobileStepperStyles = ({ theme }) => ({
  '& .MuiMobileStepper-dotActive': {
    backgroundColor: theme.palette.primary.main,
  },
});

const MuiMobileStepper = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_MOBILE_STEPPER_CLASS_NAME}`]: defaultMobileStepperStyles({ theme }),
    }),
  },
};

export default MuiMobileStepper;
